import { useMemo } from "react"
import ReportingUsage from "../components/reporting/ReportingUsage"
import { useCustomer, useCustomerError, useCustomerLoading } from "../providers/helpers/useCustomer"
import { startOfDay, endOfDay, nowDateTime, toUserTZ } from "@hydrologiq/common/helpers/date"
import { days } from "timezonecomplete"
import { Skeleton } from "@chakra-ui/react"

function CustomerReporting() {
  const customer = useCustomer()
  const loading = useCustomerLoading()
  const error = useCustomerError()

  // Fixed date range: today - 7 days to today
  const now = nowDateTime()
  const min = useMemo(() => startOfDay(customer?.createdAt ? toUserTZ(customer.createdAt) : now.sub(days(365))), [customer, now])
  const max = useMemo(() => endOfDay(now), [])

  return customer && !loading ? <ReportingUsage customer={customer} loading={loading} error={error} min={min} max={max} /> : <Skeleton height="100%" width="100%" />
}

export default CustomerReporting